<template>
  <div class="app-main-content">
    <div v-show="!showDetail" class="grid-view">
      <div class="main-content">
        <search-item
          config-module="10011"
          :reset="true"
          :custom-search-items="customSearchItems"
          :custom-sim-query-placeholder="$t('Pricing.PlsInputQuotationNo')"
          @click-more="value=>isAdvancedQuery=value"
          @advSearchItemCallBack="fetchData"
          @simSearchItemCallBack="fetchDataByKeyWord"
        >
          <div slot="operations">
            <el-button no="look" :disabled="!selectedRow || filter.total <= 0" type="success" @click="toLook()">{{ $t('common.btn.look') }} </el-button>
            <el-button v-if="$checkPermission(['button_FBAQuotation_editQuotation'])" no="edit" :disabled="!selectedRow" type="success" @click="toEdit()"> {{ $t('common.btn.edit') }} </el-button>
            <el-dropdown
              v-if="$checkPermission(['button_FBAQuotation_newQuotation'])"
              no="new"
              split-button
              type="primary"
              style="margin:0 5px"
              @click="commandHandle()"
              @command="p=>{command=p;commandHandle()}"
            >
              {{ command }}
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="$t('common.btn.new')">
                  <span style="vertical-align: middle;margin-left: 20px;">{{ $t('common.btn.new') }}</span>
                </el-dropdown-item>
                <el-dropdown-item :command="$t('Pricing.BatchImportQuotations')">
                  <img src="@/assets/fba-import.png" style="vertical-align: middle;">
                  <span style="vertical-align: middle;margin-left: 2px;">{{ $t('Pricing.BatchImportQuotations') }}</span>
                </el-dropdown-item>
                <el-dropdown-item :command="$t('Pricing.Template')">
                  <img src="@/assets/fba-download.png" style="vertical-align: middle;">
                  <span style="vertical-align: middle;margin-left: 2px;">{{ $t('Pricing.Template') }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
              <!-- 批量导入报价单-文件框 -->
              <el-upload
                v-show="false"
                action
                accept=".xls"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="toChooseFile"
              >
                <el-button ref="uploadQuotationBtn" />
              </el-upload>
            </el-dropdown>
            <el-button v-if="$checkPermission(['button_FBAQuotation_deleteQuotation'])" no="delete" :disabled="!selectedRow" type="danger" @click="toDelete()">{{ $t('SeaExport.Delete') }} </el-button>
            <!--全部导出Excel-->
            <el-button v-if="$checkPermission(['button_FBAQuotation_exportQuotation'])" no="exportAllToExcel" type="primary" @click="exportAllToExcel()">{{ $t('FbaChannel.exportQuotation') }}</el-button>
            <!--打印报价单-->
            <el-button v-if="$checkPermission(['button_FBAQuotation_printQuotation'])" no="print" type="primary" @click="print()">{{ $t('FbaChannel.printQuotation') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="1001101"
            :grid-options="gridOptions"
            :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-params.sync="gridParams"
            :check-main-record="false"
            :deselect-main-record="false"
            :show-selected-color="false"
            @gridReady="params=>{this.gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="1001101"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="()=>{if(filter.total>0){fetchDataByPage}}"
          />
        </div>
      </div>
    </div>
    <quotation-detail
      v-if="showDetail"
      ref="quotationDetail"
      @backList="toBackPreView"
    />

    <!-- 打印报表对话框 -->
    <cargo-template-select-dialog
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="{}"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </div>
</template>

<script>

import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { advancedQuery, remove, batchImportQuotation } from '@/api/price/fbaQuotation'
import QuotationDetail from '@/views/cargo/v0/FBA/Quotation/quotationDetail'
import ColumnUtils from '@/utils/ColumnUtils'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import StrUtils from '@/utils/StrUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import moment from 'moment'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { getGridSelected } from '@/utils/agGrid'
import { FbaQuotation } from '@/class/model/price/FbaQuotation'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { cacheName, cache } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'

export default {
  name: 'FBAQuotation',
  components: { CargoTemplateSelectDialog, searchItem, QuotationDetail },
  data() {
    return {
      customSearchItems: [],
      selectedRow: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        onRowSelected: this.getSelectedRow,
        onRowClicked: this.getSelectedRow,
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 50,
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: []
      },
      gridParams: {},
      gridApi: null,
      rowData: [],
      isAdvancedQuery: false, // 是否为高级查询
      showDetail: false,
      templateSelectorDialog: {
        visible: false,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      command: this.$t('common.btn.new')
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true, sortable: false, suppressMenu: true,
          suppressSizeToFit: true, resizable: false, headerCheckboxSelection: true
        },
        { headerName: this.$t('SeaExport.quotationNum'), colId: 'quotationNo', field: 'quotationNo', width: 200 },
        { headerName: this.$t('FbaChannel.channelName'), colId: 'serviceChannel', field: 'serviceChannel', width: 200 },
        { headerName: this.$t('FbaJob.quotationObject'), colId: 'quotationObject', field: 'quotationObject', width: 200 },
        { headerName: this.$t('FbaJob.quotationStatus'), colId: 'quotationStatus', field: 'quotationStatus', width: 200 },
        { headerName: this.$t('FbaChannel.quotationValidityPeriod'), colId: 'quotationValidity', field: 'quotationValidity', width: 220,
          valueFormatter: (params) => {
            const row = params.data
            if (row.active) return '长期有效'
            if (row.beginDate && row.endDate) {
              return ColumnUtils.dateLabelFunc(row.beginDate) + ' 至 ' + ColumnUtils.dateLabelFunc(row.endDate)
            }
            return ''
          } },
        { headerName: this.$t('FbaChannel.quotationLabel'), colId: 'quotationLabel', field: 'quotationLabel', width: 220 },
        { headerName: this.$t('CargoMsg.Cargo_BillingMethod'), colId: 'chargingMethod', field: 'chargingMethod', width: 180,
          valueFormatter: (params) => {
            if (!params.value) return
            return Number(params.value) ? 'CBM' : 'KG'
          } },
        { headerName: this.$t('FbaChannel.bubbleCountingRatio'), colId: 'bubbleCountingRatio', field: 'bubbleCountingRatio', width: 180 },
        { headerName: this.$t('FbaJob.BubbleSplittingRatio'), colId: 'bubbleSplittingRatio', field: 'bubbleSplittingRatio', width: 180 },
        { headerName: this.$t('SeaExport.DateOfCreation2'), colId: 'dateCreated', field: 'dateCreated', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ]
    }
  },
  created() {
    this.toQueryList(true)
  },
  methods: {
    // 高级查询
    fetchData(conditions) {
      this.filter.pageNum = 1
      const finallyConditions = []
      finallyConditions.push(...conditions)
      // 条件保存
      this.filter.snapshotConditions = finallyConditions
      this.toQueryList()
    },
    // 快捷检索
    fetchDataByKeyWord(keyWord) {
      if (!StrUtils.isEmpty(keyWord)) {
        const conditions = []
        const option = new AdvancedSearchOption(null, 'quotation.QUOTATION_NO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        this.fetchData(conditions, true)
      }
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toQueryList()
    },
    // 公共查询
    toQueryList(defaultSearch = false) {
      const { snapshotConditions: conditions, requires, pageNum, pageSize } = this.filter
      const requestBody = { conditions, requires, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize, 'defaultSearch': defaultSearch }
      this.loading = getLoading4Cxt()
      advancedQuery(requestBody).then(res => {
        const results = res.data.list
        this.rowData = results
        this.filter.total = Number(res.data.total)
        if (this.gridApi) this.gridApi.clearFocusedCell()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查看
    toLook() {
      this.showDetailDialog(this.selectedRow, 1)
    },
    // 编辑
    toEdit() {
      this.showDetailDialog(this.selectedRow, 3)
    },
    // 新增
    toAdd() {
      const row = new FbaQuotation().fillDefaultValue().getData()
      row.branchId = this.$store.getters.currentOfficeId
      this.showDetailDialog(row, 2)
    },
    showDetailDialog(row, opType) {
      if (opType !== 2 && (!row || !row.uuid)) {
        this.$message.warning('请选择报价单')
        return
      }
      this.showDetail = true
      this.$nextTick(() => {
        this.$refs.quotationDetail.onShow(row, opType)
      })
    },
    // 删除
    toDelete() {
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      const keys = Array.from(selections, p => p.uuid)
      this.loading = getLoading4Cxt()
      remove({ keys: keys }).then(res => {
        const result = res.data
        if (result.success) { // 删除成功
          this.$message.success(this.$t('Message.DeleteSucceeded'))
          // 刷新列表
          if (selections && selections.length > 0) {
            for (const row of selections) {
              const index = this.rowData.indexOf(row)
              if (index !== -1) {
                this.rowData.splice(index, 1)
              }
            }
            this.gridOptions.api.refreshCells({ force: true })
          }
        } else {
          if (result.check) {
            this.$message.warning('已经在订单中生成报价单的')
            return
          }
          this.$message.error(this.$t('Message.DeleteFail'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 选中行赋值
    getSelectedRow(event) {
      if (!event.data || !event.data.uuid) {
        return false
      }
      this.selectedRow = event.data
      return true
    },
    // 双击进详情
    onRowDoubleClicked(event) {
      if (!this.getSelectedRow(event)) return
      this.toLook()
    },
    // 返回
    toBackPreView() {
      this.selectedRow = null
      this.showDetail = false
      this.toQueryList()
    },
    // 导出报价单
    exportAllToExcel() {
      this.export = {}
      const data = this.filter.snapshotConditions
      this.export.pageNum = 1
      this.export.pageSize = 10000
      this.export.conditions = []
      this.export.branchId = this.$store.getters.currentOfficeId
      if (this.isAdvancedQuery) {
        if (typeof data !== 'undefined') {
          this.export.snapshotConditions = [... data] // 高级查询条件（点击查询时的快照状态）
          this.export.conditions = [... data]
        }
      }
      this.loading = getLoading4Cxt()
      // 导出全部，需要 实时获取 用户的 搜索条件
      advancedQuery(this.export).then(res => {
        const { columnApi } = this.gridOptions
        const allDisplayedColumns = columnApi.getAllDisplayedColumns()
        const fileName = '报价单' + '_' + moment().format('YYYYMMDDHHmmss')
        exportExcel(fileName, res.data.list, allDisplayedColumns)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 打印报价单
    print() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        return
      }
      const params = this.getPrintData(rows)
      if (!params) return
      this.templateSelectorDialog.ctx = new FbaQuotation(rows[0])
      this.templateSelectorDialog.category = 'FBA_QUOTATION' // 国外仓
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    // 组装打印参数
    getPrintData(rows) {
      const params = {}
      params.FBA_QUOTATION_UUID_LIST = Array.from(rows, p => p.uuid)
      params.category = 'FBA_QUOTATION'
      params.USER_ID = this.$store.getters.userId
      params.classNameType = SystemConstants.PRICE
      return params
    },
    // 下拉菜单处理
    commandHandle() {
      switch (this.command) {
        case this.$t('common.btn.new'):
          this.toAdd()
          break
        case this.$t('Pricing.BatchImportQuotations'):
          this.$refs.uploadQuotationBtn.$el.click()
          break
        case this.$t('Pricing.Template'):
          ExportUtils.downloadTemplateFile('FBA_LCL_sample.xls', 'price')
          break
      }
    },
    toChooseFile(file) {
      const loading = getLoading4Cxt(this)
      batchImportQuotation({ file: file.raw, branchId: this.$store.getters.currentOfficeId }).then(res => {
        const message = res.data.message
        if (message) {
          this.$message.error(message)
          return
        }
        const { successCount, failCount, fileId } = res.data
        this.$confirm(message || this.$t('Pricing.XSuccessfulXFailed', [successCount, failCount]), this.$t('SeaExport.ImportComplete'), {
          cancelButtonText: this.$t('Partners.downloadImportResults'),
          confirmButtonText: this.$t('Message.Confirm'),
          distinguishCancelAndClose: true,
          beforeClose: async(action, instance, done) => {
            if (action === 'cancel') {
              if (!fileId) {
                // 若文件ID不存在则提示结果文件上传云储存失败
                this.$message.error(this.$t('Message.ResultLogUploadFaild'))
                done()
              } else {
                await cache.load(cacheName.USER, cacheName.CONFIG)
                // const storageUrl = cache.config.get('StorageURL')
                const url = `${URL.common.findByFileId}/${fileId}?sessionId=${this.$store.getters.token}`
                const el = document.createElement('a')
                document.body.appendChild(el)
                el.href = url
                el.target = '_blank'
                el.click()
                document.body.removeChild(el)
              }
            } else {
              done()
            }
          }
        })
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style scoped>

</style>
